// extracted by mini-css-extract-plugin
export var sbShowMain = "slideIn-module--sb-show-main--VBMKd";
export var wrapper = "slideIn-module--wrapper--C9d6O";
export var absolute = "slideIn-module--absolute--gW_xJ";
export var inner = "slideIn-module--inner--1fr9Y";
export var left = "slideIn-module--left--1zIkP";
export var right = "slideIn-module--right--1JnmW";
export var slideIn = "slideIn-module--slideIn--3cI-J";